import jsPDF from 'jspdf';
import { safeText } from './format';

const formatDate = (value) => {
  if (!value) return '-';
  const d = value.toDate ? value.toDate() : new Date(value);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleString();
};

const wrapText = (doc, text, maxWidth) => {
  if (!text) return [''];
  const safe = typeof text === 'string' ? text : safeText(text);
  return doc.splitTextToSize(safe, maxWidth);
};

/**
 * Generate a single-report PDF and trigger download.
 * @param {object} report — full report doc as loaded from Firestore.
 * @param {object} actor — { email } of the admin generating the export.
 */
export const exportReportToPdf = (report, actor = {}) => {
  if (!report) return;
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const margin = 48;
  const pageWidth = doc.internal.pageSize.getWidth();
  const contentWidth = pageWidth - margin * 2;
  let y = margin;

  // Header
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.setTextColor(14, 165, 233);
  doc.text('Dierend — User Report', margin, y);
  y += 26;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(100);
  doc.text(`Generated ${new Date().toLocaleString()}${actor.email ? ` · by ${actor.email}` : ''}`, margin, y);
  y += 18;

  // Divider
  doc.setDrawColor(220);
  doc.line(margin, y, pageWidth - margin, y);
  y += 18;

  const writeRow = (label, value) => {
    if (y > 760) {
      doc.addPage();
      y = margin;
    }
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(120);
    doc.text(label.toUpperCase(), margin, y);
    y += 14;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(20);
    const lines = wrapText(doc, value || '—', contentWidth);
    lines.forEach((line) => {
      if (y > 790) {
        doc.addPage();
        y = margin;
      }
      doc.text(line, margin, y);
      y += 14;
    });
    y += 8;
  };

  writeRow('Report ID', report.id);
  writeRow('Type', report.type);
  writeRow('Status', report.status);
  if (report.resolution) writeRow('Resolution', report.resolution);
  writeRow('Reason', report.reason);
  if (report.description) writeRow('Description', report.description);
  writeRow('Reporter UID', report.userId);
  if (report.reporterEmail) writeRow('Reporter Email', report.reporterEmail);
  if (report.reportedId) writeRow('Reported Item ID', report.reportedId);
  if (report.reportedUserId) writeRow('Reported User UID', report.reportedUserId);
  writeRow('Created', formatDate(report.createdAt));
  if (report.resolvedAt) writeRow('Resolved', formatDate(report.resolvedAt));
  if (report.resolvedBy) writeRow('Resolved By', report.resolvedBy);
  if (report.resolutionNotes) writeRow('Resolution Notes', report.resolutionNotes);

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i += 1) {
    doc.setPage(i);
    doc.setFontSize(9);
    doc.setTextColor(150);
    doc.text(
      `Dierend Admin · Confidential · Page ${i} of ${pageCount}`,
      margin,
      doc.internal.pageSize.getHeight() - 24
    );
  }

  doc.save(`dierend-report-${report.id}.pdf`);
};

export default exportReportToPdf;
